module.exports = ""


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/freshdesk-chat/freshdesk-chat.component.html
// module id = G9yx
// module chunks = 6